module.exports = __webpack_public_path__ + "static/heidi8-d7acbe8f654474e0092ce64ea713c1bb.jpg";